import axios from "axios";

// Prefer same-origin so API calls always go to the domain the app is served
// from — production (https://rhythmchecktraining.com/api/...) or preview.
// This avoids a stale REACT_APP_BACKEND_URL being baked into the bundle at
// build time and pointing at the wrong environment. `REACT_APP_BACKEND_URL`
// is kept as a fallback for local/tooling contexts where `window` isn't
// available.
const BACKEND_URL =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Also attach Authorization bearer if we stored a token from login
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rct_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
